import React, { useState } from "react";
import { PuffLoader } from "react-spinners";
import Features from "./Features";
import { Form } from "../../../styles";
import { ICON_FROWN } from "../../../utils/icons";
import { useParams } from "react-router-dom";
import { useUserContext } from "../../../context/user_context";
import { allFeatures } from "../../../utils/data";

const StaffFeature = () => {

  const [load, setload] = useState(false);
  const [workF, setworkF] = useState(true);

  //  Get All Features

  const params = useParams();
  const { id: staffToken } = params;

  const { usertoken, businessData } = useUserContext();
  const ownerToken = businessData?.owner_token;


  return (
    <>

      <Form>
        <div className="row justify-content-center text-start mt-4">
          {load ? (
            <div className=" mb-5 col-md-12 text-center">
              <PuffLoader color="var(--pry-bold-color)" size={"60"} />
            </div>
          ) : (
            <>
              {staffToken === ownerToken ?
                // {false ?
                (<>
                  <div className="red-text text-center">
                    <span className="display-3 pb-3">
                      {ICON_FROWN}
                    </span>
                    <p className="mt-4">
                      Sorry, you cannot edit the Business Owner
                    </p>
                  </div>
                </>
                ) : (
                  <>
                    {staffToken === usertoken ?
                      // {false ?
                      <>
                        <div className="red-text text-center">

                          <span className="display-3 pb-3">
                            {ICON_FROWN}
                          </span>
                          <p className="mt-4">
                            Sorry, you cannot edit yourself
                          </p>
                        </div>
                      </> : (
                        <>
                          <div className="col-md-12">
                            <div className="row justify-content-center">
                              {workF &&
                                <>
                                  {allFeatures?.map((item, i) => {
                                    return (
                                      <Features
                                        key={i}
                                        name={item.name}
                                        value={item.value}
                                        work={workF}
                                        staff={staffToken}
                                      />
                                    );
                                  })}
                                </>}
                            </div>
                          </div>
                        </>
                      )
                    }
                  </>
                )}

            </>
          )}
        </div>
      </Form>


    </>
  );
};

export default StaffFeature;
